import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Loader from '../../components/Loader';
import {
  fetchObject,
} from '../../redux/actions';

import {
  getId,
  selectHydrated
} from '../../redux/modules/objects/selectors';

import {
  getId as getProductId,
} from '../../redux/modules/products/selectors';

import './ObjectDetails.scss'

import Controls from './Controls';
import Gallery from '../../components/Gallery';


class ObjectDetails extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    object: PropTypes.object,
    product: PropTypes.object
  }

  render() {
    const { object, product } = this.props;
    return (
      <div className="col-lg-9 col-sm-12 object-details">
        <Loader loaded={!!object}>
          {object && (
            <div className="d-flex container-fluid mt-3">
              <div className="col">
                <h1>
                  <Link to="/browse" className="back-btn">
                    <i className="fa fa-long-arrow-left"/>
                  </Link>
                  {object.address} <small className="text-muted">#{object.code}</small>
                </h1>
                {(product && product.images.length > 0) && <Gallery images={product.images}/>}
                <Controls {...object} product={product} />
              </div>
            </div>)}
        </Loader>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  const id = getId(state, props);
  const rawObject = selectHydrated(state, id);
  // Only hydrated products are viable here
  const object = rawObject && rawObject.products ? rawObject : null;
  const productId = getProductId(state, props);

  let product = (object && productId)
    ? object.products.find(p => p.id === productId)
    : null;

  return {
    id,
    object,
    product
  };
}

export default connect(mapStateToProps, {fetchObject})(ObjectDetails);


// WEBPACK FOOTER //
// ./src/scenes/ObjectDetails/index.js